console.log('🧪 Signature system loaded');

/* ======================================================
   0️⃣ 生成稳定的 userId（浏览器级，兼容版）
====================================================== */
function generateUUID() {
  if (window.crypto && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return 'xxxxxxxyxxxx'.replace(/[xy]/g, c => {
    const r = Math.random() * 16 | 0;
    return r.toString(16);
  });
}

(function initSignatureUserId() {
  const KEY = 'signature_user_id';
  if (!localStorage.getItem(KEY)) {
    const uuid = 'u_' + generateUUID();
    localStorage.setItem(KEY, uuid);
    console.log('🆔 Generated signature userId:', uuid);
  }
})();

/* ======================================================
   1️⃣ 全局配置
====================================================== */
window.signatureConfig = {
  fontUrl: "{{ 'CV2.3.otf' | asset_url }}",
  labelFontUrl: "{{ 'nameLabel.otf' | asset_url }}",
  fontSize: 160,
  api: {
    renderDesign: 'https://api.tomorrowcrafted.com/svgRenderDesign',
    uploadPng: 'https://api.tomorrowcrafted.com/api/design/upload-png'
  }
};

/* ======================================================
   2️⃣ 全局状态（唯一可信）
====================================================== */
window.SIGNATURE_DEBUG = false;

window.__DESIGN_REQUESTING__ = false;
window.__DESIGN_READY__ = false;
window.__PNG_READY__ = false;

window.__DESIGN_CODES__ = {
  style1: null,
  style2: null
};

window.__FINAL_DESIGN_PAYLOAD__ = null;

window.__LAST_RENDERED_SVGS__ = {
  style1: null,
  style2: null
};

window.selectedStyle = null;
window.currentDesignUrl = null;

/* ======================================================
  2.5️⃣ 同步定制属性到商品表单
====================================================== */
function syncDesignPropertiesToForms(payload) {
  const forms = document.querySelectorAll('form[action*="/cart/add"]');
  if (!forms.length) return;

  forms.forEach((form) => {
    const customNameInput = form.querySelector('#prop-custom-name');
    const selectedStyleInput = form.querySelector('#prop-selected-style');
    const designPreviewInput = form.querySelector('#prop-design-preview');
    const designCodeInput = form.querySelector('#prop-design-code');

    if (!customNameInput || !selectedStyleInput || !designPreviewInput || !designCodeInput) return;

    customNameInput.value = payload?.name || '';
    selectedStyleInput.value = payload?.style || '';
    designPreviewInput.value = payload?.preview || '';
    designCodeInput.value = payload?.code ? JSON.stringify(payload.code) : '';
  });
}

/* ======================================================
   3️⃣ SVG 注入工具
====================================================== */
function injectSvg(container, svgString) {
  if (!container || !svgString) return;

  container.innerHTML = svgString;
  const svg = container.querySelector('svg');

  if (svg) {
    svg.removeAttribute('width');
    svg.removeAttribute('height');
    svg.style.width = '100%';
    svg.style.height = '100%';
    svg.setAttribute('preserveAspectRatio', 'xMidYMid meet');
  }
}

/* ======================================================
   4️⃣ Design 倒计时
====================================================== */
function startDesignCountdown(seconds = 3) {
  const btn = document.getElementById('submitBtn');
  if (!btn) return Promise.resolve();

  let remain = seconds;
  btn.disabled = true;
  btn.textContent = remain;

  return new Promise(resolve => {
    const timer = setInterval(() => {
      remain--;
      if (remain > 0) {
        btn.textContent = remain;
      } else {
        clearInterval(timer);
        btn.textContent = 'Design';
        btn.disabled = false;
        resolve();
      }
    }, 1000);
  });
}

/* ======================================================
   5️⃣ SVG → PNG
====================================================== */
function svgToPngDataUrl(svgEl, scale = 3) {
  return new Promise((resolve, reject) => {
    if (!svgEl) return reject('SVG not found');

    const clone = svgEl.cloneNode(true);
    clone.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

    const svgStr = new XMLSerializer().serializeToString(clone);
    const svgBlob = new Blob([svgStr], { type: 'image/svg+xml;charset=utf-8' });
    const url = URL.createObjectURL(svgBlob);

    const img = new Image();
    img.onload = () => {
      const vb = clone.viewBox.baseVal;
      const canvas = document.createElement('canvas');
      canvas.width = vb.width * scale;
      canvas.height = vb.height * scale;
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(url);
      resolve(canvas.toDataURL('image/png'));
    };

    img.onerror = reject;
    img.src = url;
  });
}

/* ======================================================
   6️⃣ 上传 PNG
====================================================== */
async function uploadDesignToServer({ pngBase64, name, style }) {
  const res = await fetch(window.signatureConfig.api.uploadPng, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ pngBase64, name, style })
  });

  const json = await res.json();
  if (!json.success) throw new Error('Upload failed');
  return json.data;
}

/* ======================================================
   7️⃣ 点击 Design
====================================================== */
// document.getElementById('submitBtn')?.addEventListener('click', async (e) => {
//   e.preventDefault();
//   e.stopPropagation();

//   if (window.__DESIGN_REQUESTING__) return;
//   window.__DESIGN_REQUESTING__ = true;

//   try {
//     const name = document.getElementById('name')?.value.trim();
//     if (!name) {
//       alert('Please enter your name');
//       return;
//     }

//     window.__DESIGN_READY__ = false;
//     window.__PNG_READY__ = false;
//     window.__FINAL_DESIGN_PAYLOAD__ = null;
//     window.__DESIGN_CODES__ = { style1: null, style2: null };

//     document.querySelectorAll('.style-btn').forEach(b => b.classList.remove('active'));

//     const svg1 = document.getElementById('svgOutput');
//     const svg2 = document.getElementById('svgOutput2');
//     const label1 = document.getElementById('nameLabel1');
//     const label2 = document.getElementById('nameLabel2');

//     svg1.innerHTML = svg2.innerHTML = label1.innerHTML = label2.innerHTML = '';

//     const fetchPromise = fetch(window.signatureConfig.api.renderDesign, {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         name,
//         userId: localStorage.getItem('signature_user_id'),
//         debug: window.SIGNATURE_DEBUG === true
//       })
//     }).then(async r => {
//       if (!r.ok) {
//         let err;
//         try {
//           err = await r.json();
//         } catch {
//           err = { code: r.status };
//         }
//         throw err;
//       }
//       return r.json();
//     });

//     const json = await fetchPromise;
//     await startDesignCountdown(3);

//     const designList = json?.data?.designList || [];
//     const labelList = json?.data?.labelList || [];

//     injectSvg(svg1, designList[0]?.svg);
//     injectSvg(svg2, designList[1]?.svg);

//     if (labelList[0]) injectSvg(label1, labelList[0].svg);
//     if (labelList[1]) injectSvg(label2, labelList[1].svg);

//     window.__LAST_RENDERED_SVGS__.style1 = svg1.querySelector('svg');
//     window.__LAST_RENDERED_SVGS__.style2 = svg2.querySelector('svg');

//     window.__DESIGN_CODES__.style1 = designList[0]?.code || null;
//     window.__DESIGN_CODES__.style2 = designList[1]?.code || null;

//     window.__DESIGN_READY__ = true;

//   } catch (err) {
//     if (err?.code === 429 || err?.status === 429) {
//       alert(
//         'You have reached the daily design limit.\n' +
//         'You can design up to 5 different names within 24 hours.'
//       );
//     } else {
//       alert('Failed to generate design. Please try again later.');
//     }
//   } finally {
//     window.__DESIGN_REQUESTING__ = false;
//   }
// });
// document.getElementById('submitBtn')?.addEventListener('click', async (e) => {
//   e.preventDefault();
//   e.stopPropagation();

//   if (window.__DESIGN_REQUESTING__) return;
//   window.__DESIGN_REQUESTING__ = true;

//   const name = document.getElementById('name')?.value.trim();
//   if (!name) {
//     alert('Please enter your name');
//     window.__DESIGN_REQUESTING__ = false;
//     return;
//   }

//   // ===== 立刻重置状态 =====
//   window.__DESIGN_READY__ = false;
//   window.__PNG_READY__ = false;
//   window.__FINAL_DESIGN_PAYLOAD__ = null;
//   window.__DESIGN_CODES__ = { style1: null, style2: null };

//   document.querySelectorAll('.style-btn').forEach(b => b.classList.remove('active'));

//   const svg1 = document.getElementById('svgOutput');
//   const svg2 = document.getElementById('svgOutput2');
//   const label1 = document.getElementById('nameLabel1');
//   const label2 = document.getElementById('nameLabel2');

//   svg1.innerHTML = svg2.innerHTML = label1.innerHTML = label2.innerHTML = '';

//   // ⭐ 关键：倒计时和 fetch 同时开始
//   const countdownPromise = startDesignCountdown(3);

//   try {
//   const fetchPromise = fetch(window.signatureConfig.api.renderDesign, {
//   method: 'POST',
//   headers: { 'Content-Type': 'application/json' },
//   body: JSON.stringify({
//     name,
//     userId: localStorage.getItem('signature_user_id'),
//     debug: window.SIGNATURE_DEBUG === true
//   })
// }).then(async r => {
//   const json = await r.json();

//   // ⭐⭐ 关键：业务级错误判断
//   if (!r.ok || json?.code === 429) {
//     throw {
//       status: json?.code || r.status,
//       message: json?.msg
//     };
//   }

//   return json;
// });


//     // ⭐ 等后端（倒计时已经在跑）
//     const json = await fetchPromise;

//     const designList = json?.data?.designList || [];
//     const labelList  = json?.data?.labelList  || [];
// // 等倒计时结束，再展示 SVG（核心）
// await countdownPromise;

// injectSvg(svg1, designList[0]?.svg);
// injectSvg(svg2, designList[1]?.svg);

// if (labelList[0]) injectSvg(label1, labelList[0].svg);
// if (labelList[1]) injectSvg(label2, labelList[1].svg);

// window.__LAST_RENDERED_SVGS__.style1 = svg1.querySelector('svg');
// window.__LAST_RENDERED_SVGS__.style2 = svg2.querySelector('svg');

// window.__DESIGN_CODES__.style1 = designList[0]?.code || null;
// window.__DESIGN_CODES__.style2 = designList[1]?.code || null;

// window.__DESIGN_READY__ = true;

   

//   } catch (err) {
//     // ⭐ 移动端安全提示（不要只用 alert）
//     if (err?.code === 429 || err?.status === 429) {
//       setTimeout(() => {
//         alert(
//   'You’ve reached today’s limit of 5 new names.\n\n' +
//   'You can still re-enter and view any name\n' +
//   'you already designed today.\n\n' +
//   'New design slots will reset after 24 hours.'
// );

//       }, 50);
//     } else {
//       setTimeout(() => {
//         alert('Failed to generate design. Please try again later.');
//       }, 50);
//     }
//   } finally {
//     // 等倒计时自然结束（不阻塞）
//     countdownPromise.finally(() => {
//       window.__DESIGN_REQUESTING__ = false;
//     });
//   }
// });

document.getElementById('submitBtn')?.addEventListener('click', async (e) => {
  e.preventDefault();
  e.stopPropagation();

  const btn = e.currentTarget;

  // ⭐ 第一帧立刻锁死
  if (window.__DESIGN_REQUESTING__) return;
  window.__DESIGN_REQUESTING__ = true;

  btn.disabled = true;                 // 立刻变灰
  btn.style.opacity = '0.45';
  btn.style.pointerEvents = 'none';

  const name = document.getElementById('name')?.value.trim();
  if (!name) {
    alert('Please enter your name');

    // 回滚按钮状态
    btn.disabled = false;
    btn.style.opacity = '';
    btn.style.pointerEvents = '';
    window.__DESIGN_REQUESTING__ = false;
    return;
  }

  // ===== 立刻重置状态 =====
  window.__DESIGN_READY__ = false;
  window.__PNG_READY__ = false;
  window.__FINAL_DESIGN_PAYLOAD__ = null;
  window.__DESIGN_CODES__ = { style1: null, style2: null };

  document.querySelectorAll('.style-btn').forEach(b => b.classList.remove('active'));

  const svg1   = document.getElementById('svgOutput');
  const svg2   = document.getElementById('svgOutput2');
  const label1 = document.getElementById('nameLabel1');
  const label2 = document.getElementById('nameLabel2');

  svg1.innerHTML = '';
  svg2.innerHTML = '';
  label1.innerHTML = '';
  label2.innerHTML = '';

  // ⭐ 倒计时与 fetch 同时开始
  const countdownPromise = startDesignCountdown(3);

  try {
    const fetchPromise = fetch(window.signatureConfig.api.renderDesign, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name,
        userId: localStorage.getItem('signature_user_id'),
        debug: window.SIGNATURE_DEBUG === true
      })
    }).then(async r => {
      const json = await r.json();

      // ⭐ 业务级错误（429）
      if (!r.ok || json?.code === 429) {
        throw {
          status: json?.code || r.status,
          message: json?.msg
        };
      }

      return json;
    });

    // 等后端返回（倒计时仍在跑）
    const json = await fetchPromise;

    const designList = json?.data?.designList || [];
    const labelList  = json?.data?.labelList  || [];

    // ⭐⭐ 关键：等倒计时结束才展示设计
    await countdownPromise;

    injectSvg(svg1, designList[0]?.svg);
    injectSvg(svg2, designList[1]?.svg);

    if (labelList[0]) injectSvg(label1, labelList[0].svg);
    if (labelList[1]) injectSvg(label2, labelList[1].svg);

    window.__LAST_RENDERED_SVGS__.style1 = svg1.querySelector('svg');
    window.__LAST_RENDERED_SVGS__.style2 = svg2.querySelector('svg');

    window.__DESIGN_CODES__.style1 = designList[0]?.code || null;
    window.__DESIGN_CODES__.style2 = designList[1]?.code || null;

    window.__DESIGN_READY__ = true;

  } catch (err) {
    if (err?.status === 429) {
      setTimeout(() => {
  showDesignLimitModal();


      }, 50);
    } else {
      setTimeout(() => {
        alert('Failed to generate design. Please try again later.');
      }, 50);
    }
  } finally {
    // ⭐ 倒计时真正结束后才允许再次点击
    countdownPromise.finally(() => {
      window.__DESIGN_REQUESTING__ = false;

      btn.disabled = false;
      btn.style.opacity = '';
      btn.style.pointerEvents = '';
    });
  }
});

/* ======================================================
   8️⃣ 点击 Style
====================================================== */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.style-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const style = btn.dataset.style;
      const name = document.getElementById('name')?.value.trim();

      if (!window.__DESIGN_READY__) {
        alert('Please click Design first');
        return;
      }

      const svgEl = window.__LAST_RENDERED_SVGS__[style];
      const code = window.__DESIGN_CODES__[style];

      if (!svgEl || !code) {
        alert('Design code missing, please re-design');
        return;
      }

      const pngBase64 = await svgToPngDataUrl(svgEl);
      const preview = await uploadDesignToServer({ pngBase64, name, style });

      window.__PNG_READY__ = true;
      window.__FINAL_DESIGN_PAYLOAD__ = { name, style, preview, code };
      syncDesignPropertiesToForms(window.__FINAL_DESIGN_PAYLOAD__);

      document.querySelectorAll('.style-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
    });
  });
});

/* ======================================================
   9️⃣ Add to Cart 校验
====================================================== */
document.addEventListener('submit', (e) => {
  const form = e.target;
  if (!form || !form.action.includes('/cart/add')) return;

  const p = window.__FINAL_DESIGN_PAYLOAD__;

  if (!p || !p.name || !p.style || !p.preview || !p.code) {
    alert('Please finish your design before adding to cart');
    e.preventDefault();
    return;
  }

  syncDesignPropertiesToForms(p);

  form.querySelectorAll('input[data-custom-property]').forEach(i => i.remove());

  const props = {
    'Custom Name': p.name,
    'Selected Style': p.style,
    'Design Preview': p.preview,
    '_DesignCode': JSON.stringify(p.code)
  };

  Object.entries(props).forEach(([k, v]) => {
    const i = document.createElement('input');
    i.type = 'hidden';
    i.name = `properties[${k}]`;
    i.value = v;
    i.setAttribute('data-custom-property', '1');
    form.appendChild(i);
  });
}, true);
function showDesignLimitModal() {
  const modal = document.getElementById('designLimitModal');
  const okBtn = document.getElementById('designModalOk');

  modal.classList.remove('hidden');

  okBtn.onclick = () => {
    modal.classList.add('hidden');
  };
}


